import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterProduct } from "../../redux/features/search/searchSlice";

const CatNav = () => {
  const { filterCategory, sort } = useSelector((state) => state.search);

  const dispatch = useDispatch();

  const categories = ["Laptop", "Mobile", "SmartWatch", "Monitor"];

  const CatNavHandler = (category) => {
    dispatch(filterProduct(category));
  };

  return (
    <>
      <div className=" fixed z-50  flex flex-row items-center  bg-slate-100 w-full pb-2 [&>*]:mr-2 pt-2">
        <button
          onClick={() => dispatch(filterProduct("All"))}
          className={`${
            filterCategory === "All" ? "bg-slate-900 text-white" : "bg-white"
          } px-2   rounded`}
          to="/products/"
        >
          All
        </button>

        {categories.map((category) => (
          <button
            onClick={() => {
              CatNavHandler(category);
            }}
            className={`${
              filterCategory === `${category}`
                ? "bg-slate-900 text-white"
                : "bg-white"
            } px-2 rounded`}
            to="/products/"
          >
            {category}
          </button>
        ))}
      </div>
    </>
  );
};

export default CatNav;
